import { RouteConfig } from 'vue-router';

import MailTemplates from '@/views/mailTemplate/List.vue';

export const mailTemplatesRoute: RouteConfig = {
  path: '',
  name: 'mailTemplates',
  component: MailTemplates,
  meta: { authorized: true }
};
